export const isSalesTransferDestinationBranchMatch = (
  branchKeyword?: string,
  destinationBranch?: string
) => {
  const normalizedBranchKeyword = (branchKeyword || '').trim().toLowerCase();
  const normalizedDestinationBranch = (destinationBranch || '')
    .trim()
    .toLowerCase();

  if (!normalizedBranchKeyword || !normalizedDestinationBranch) {
    return false;
  }

  return (
    normalizedDestinationBranch === normalizedBranchKeyword ||
    normalizedDestinationBranch.startsWith(`${normalizedBranchKeyword} `)
  );
};
